import { render, staticRenderFns } from "./KendaraanDerekLaporanPage.vue?vue&type=template&id=5c545f00"
import script from "./KendaraanDerekLaporanPage.vue?vue&type=script&lang=js"
export * from "./KendaraanDerekLaporanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports